export default __webpack_public_path__ + "static/media/logo-dark-css-animation.eda2187d.svg";